<template>
  <section>
    <div class="columns is-gapless is-centered">
      <div class="column is-fullheight">
        <div class="hero-body">
          <article>
            <div class="card-content">
              <h1 class="title has-text-centered">
                <router-link to="/">
                  <img src="/static/img/logo/logo.svg" alt="logo" width="400"/>
                </router-link>
              </h1>
              <div class="columns is-mobile is-centered">
                <div class="column is-narrow is-marginless is-centered is-warning">
                  <span class="icon is-size-4 is-white">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
                </div>
                <div class="column is-warning-middle is-10-mobile is-6-tablet is-6-desktop">
                  <p class="is-size-6">
                    We cannot find what you're looking for. Either the URL is incorrect OR the link has expired.
                  </p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo: {
    title: 'Hellopeter | 404 Page Not Found!'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: '404 Page Not Found!'
    })
    window.prerenderReady = true
  },
  name: '404'
}
</script>

<style scoped>
h1 {
  color: #cd0930 !important;
  margin-bottom: 3rem !important;
}

.is-warning {
  color: #fff;
  background-color: #fb922c;
}

.is-warning-middle {
  background-color: #faddc1;
}

.router-link-active {
  background: none !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue